module.exports = __webpack_public_path__ + "img/93977.f2f28f98.svg";